import { render, staticRenderFns } from "./PortalLayout.vue?vue&type=template&id=f19e7c76&scoped=true"
import script from "./PortalLayout.vue?vue&type=script&lang=js"
export * from "./PortalLayout.vue?vue&type=script&lang=js"
import style0 from "./PortalLayout.vue?vue&type=style&index=0&id=f19e7c76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f19e7c76",
  null
  
)

export default component.exports